export enum YesNoModalTypeEnum {
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
  DANGER = "DANGER",
  PRIMARY = "PRIMARY",
  INFO = "INFO"
}

